import { Button } from '~/components/ui/button';
import { clearSourceBlob } from '~/features/source/idb';
import { useStore } from '~/store';

/**
 * Wipe persisted settings, undo history and the cached source blob, then
 * reload. Used to confirm that a misbehaviour isn't being caused by a stale
 * value carried over from a previous session.
 */
async function resetAll() {
  if (!window.confirm('Reset all settings and reload? The current image will be cleared.')) return;
  useStore.persist?.clearStorage();
  useStore.temporal.getState().clear();
  await clearSourceBlob();
  window.location.reload();
}

export function ResetButton() {
  return (
    <Button
      onClick={() => {
        void resetAll();
      }}
      variant="ghost"
      size="sm"
      className="h-8"
    >
      Reset
    </Button>
  );
}
